export default __webpack_public_path__ + "static/media/roadworkIcon.13744002.svg";